<template>
  <section id="references">
    <div class="section-head reveal">
      <div class="section-label">{{ m.references.label }}</div>
      <h2>{{ m.references.titleLine1 }}<br><em>{{ m.references.titleLine2 }}</em></h2>
    </div>
    <div class="ref-grid">
      <div
        v-for="(ref, index) in m.references.items"
        :key="index"
        class="ref-card reveal"
        :style="refDelay(index)"
      >
        <img :src="refImages[index]" :alt="ref.alt">
        <div class="ref-info">
          <div class="ref-tag">{{ ref.tag }}</div>
          <h3 class="ref-title">{{ ref.title }}</h3>
          <div class="ref-desc">{{ ref.desc }}</div>
        </div>
      </div>
    </div>

    <div style="text-align:center; margin-top: 2rem;">
      <p style="font-size:12.5px; color: var(--text-dim);">{{ m.references.more }}</p>
    </div>
  </section>
</template>

<script setup lang="ts">
const { messages: m } = useI18n()

const refImages = [
  '/img/ref1.jpg',
  '/img/ref2.jpg',
  '/img/ref4.jpg',
  '/img/ref6.jpg',
  '/img/ref7.jpg',
  '/img/ref9.jpg',
  '/img/ref3.jpg',
  '/img/ref5.jpg',
  '/img/ref8.png'
]

const refDelays = [undefined, '.08s', '.16s', undefined, '.08s', '.16s', undefined, '.08s', '.16s']

const refDelay = (index: number) => {
  const delay = refDelays[index]
  return delay ? { transitionDelay: delay } : undefined
}
</script>